// Mapea los errores de validacion 422 de Laravel a los campos de un formulario de react-hook-form
export function applyServerErrors(error, setError) {
  const status = error?.response?.status;
  const errors = error?.response?.data?.errors;

  if (status === 422 && errors) {
    Object.entries(errors).forEach(([field, messages]) => {
      setError(field, { type: 'server', message: Array.isArray(messages) ? messages[0] : messages });
    });
    return true;
  }

  return false;
}

// Extrae un mensaje de error legible desde una respuesta de axios
export function getErrorMessage(error, fallback = 'Ocurrió un error inesperado. Inténtalo de nuevo.') {
  return error?.response?.data?.message || fallback;
}

// Igual que getErrorMessage, pero para peticiones con `responseType: 'blob'` (descargas de
// PDF): axios respeta ese responseType incluso en una respuesta de error, asi que el JSON
// `{ message: '...' }` del backend llega como un Blob binario en vez de objeto ya parseado
// -  sin esto, error.response.data.message siempre es undefined y se pierde el motivo real.
export async function getBlobErrorMessage(error, fallback = 'Ocurrió un error inesperado. Inténtalo de nuevo.') {
  const data = error?.response?.data;

  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text());
      return parsed?.message || fallback;
    } catch {
      return fallback;
    }
  }

  return getErrorMessage(error, fallback);
}
